var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1745579,1.63198796 L21.7122396,10.1700145 C22.1853904,10.6613223 22.1706345,11.4434979 21.6834741,11.9129239 L13.1613124,20.4345459 C12.6716585,20.9227816 11.8794175,20.9216853 11.3866725,20.4274099 C10.9157649,19.9342964 10.9157649,19.1581304 11.3916676,18.6599094 L17.7669236,12.2946342 L1.13532219,12.2942338 C0.492132973,12.2602514 -0.0219445463,11.7462805 -0.0559113607,11.1030339 C-0.0927087856,10.4081287 0.440554729,9.81500571 1.15115041,9.777779 L17.7684388,9.777779 L11.4220861,3.42237116 C11.3644014,3.37418332 11.3109779,3.32058258 11.2622289,3.26222608 C10.8173895,2.72919805 10.8890201,1.93633291 11.4222719,1.49160236 L11.5322969,1.40949971 C12.0597215,1.05861473 12.7765825,1.15301719 13.1745579,1.63198796 Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.c67c22cb7998c39ccb7788c872024ad1.svg";
export { ForwardRef as ReactComponent };